import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import { getWorkspacePath } from '@sales-app/context/workspace/workspace.util'
import clsx from 'clsx'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useUserContext } from '@/context'
import { AgentRoles } from '@/context/user/user.types'

import { AgentStatus } from './AgentStatus'

export const BottomBar = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [{ tabs, activeTabId, activeTabType }] = useWorkspaceContext()
  const { user } = useUserContext()
  const allowStatusBar = user?.agent?.role === AgentRoles.SUPERVISOR || user?.agent?.role === AgentRoles.AGENT

  const sortedTabs = tabs.sort((a, b) => Number(b.lastAccessedTime) - Number(a.lastAccessedTime))
  const showActivWorkspaceTabs = !pathname.includes('workspace')

  const openTab = (tab: WorkspaceTab) => {
    const { view, potentialBookingId, bookablePersonId, bookablePersonType } = tab
    const path = getWorkspacePath({
      view: view,
      type: bookablePersonType,
      id: bookablePersonId,
      potentialBookingId: potentialBookingId,
    })

    navigate(path)
  }

  return (
    <div className="fixed bottom-0 right-4 z-50 flex items-end">
      {tabs.length > 0 && showActivWorkspaceTabs && (
        <>
          {sortedTabs.map((t, i) => {
            if (i > 3) {
              return null
            }
            return (
              <button
                className={clsx(
                  'mr-4 flex h-10 items-center rounded-t-md border px-3 border-secondary',
                  t.bookablePersonId === activeTabId && t.bookablePersonType === activeTabType
                    ? 'bg-yellow-200'
                    : 'bg-action-secondary',
                )}
                key={t.bookablePersonId}
                onClick={() => openTab(t)}
              >
                <p className="mr-3">{t.label}</p>
              </button>
            )
          })}
        </>
      )}
      {allowStatusBar && <AgentStatus />}
    </div>
  )
}
